import { render, staticRenderFns } from "./CardMaisFiltros.vue?vue&type=template&id=2786513a"
import script from "./CardMaisFiltros.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardMaisFiltros.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports